import React from "react";

import TeamDetailNextMatchCard from "./TeamDetailNextMatchCard";

const TeamDetailHero = ({
  loading,
  sportsDbTeam,
  badge,
  decodedTeamName,
  leagueName,
  record,
  teamColors,
  liveMatch,
  nextMatch,
  nextMatchLoading,
  formResults,
  coach,
  onMatchClick,
  onBack,
  heroRef,
}) => {
  const heroBackdrop =
    sportsDbTeam?.strFanart1 ||
    sportsDbTeam?.strFanart2 ||
    sportsDbTeam?.strBanner ||
    null;

  const competitions = [
    sportsDbTeam?.strLeague,
    sportsDbTeam?.strLeague2,
    sportsDbTeam?.strLeague3,
    sportsDbTeam?.strLeague4,
    sportsDbTeam?.strLeague5,
    sportsDbTeam?.strLeague6,
    sportsDbTeam?.strLeague7,
  ].filter(Boolean);

  return (
    <div className="relative h-[45vh] min-h-[360px]" ref={heroRef}>
      {heroBackdrop ? (
        <img
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          src={heroBackdrop}
        />
      ) : (
        <div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(135deg, ${teamColors.primary}40, ${teamColors.secondary}40)`,
          }}
        />
      )}

      {/* Gradient overlay — heavier at bottom for text readability, lighter at top to show image */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/20" />

      <div className="absolute top-6 left-28 right-8 z-20">
        <button
          className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm focus:outline-none focus:ring-2 focus:ring-white/30 rounded-lg px-2 py-1"
          tabIndex={0}
          onClick={onBack}
        >
          <i className="fas fa-arrow-left" />
          Back
        </button>
      </div>

      <div className="relative z-10 h-full flex items-end pl-28 pr-8 pb-8 pt-8">
        {loading ? (
          <div className="flex items-end gap-6 animate-pulse flex-1">
            <div className="w-24 h-24 rounded-2xl bg-white/10" />
            <div className="space-y-3">
              <div className="h-10 w-64 bg-white/10 rounded" />
              <div className="h-5 w-40 bg-white/10 rounded" />
            </div>
          </div>
        ) : (
          <div className="flex items-end justify-between w-full gap-8">
            <div className="flex-1 min-w-0">
              <div className="flex items-end gap-6">
                {badge && (
                  <img
                    alt={decodedTeamName}
                    className="w-24 h-24 object-contain drop-shadow-2xl flex-shrink-0"
                    src={badge}
                  />
                )}
                <div className="min-w-0">
                  <h1 className="text-4xl font-bold text-white drop-shadow-lg truncate">
                    {sportsDbTeam?.strTeam || decodedTeamName}
                  </h1>
                  {leagueName && (
                    <p className="text-white/60 text-lg mt-1">{leagueName}</p>
                  )}
                  {record && (
                    <p className="text-white/80 text-sm mt-1">
                      W{record.wins} D{record.draws} L{record.losses}
                      {record.position && <> &middot; #{record.position}</>}
                      {record.points !== null && (
                        <> &middot; {record.points} pts</>
                      )}
                    </p>
                  )}
                </div>
              </div>

              {competitions.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-4">
                  {competitions.map((league) => (
                    <span
                      className="px-2.5 py-1 rounded-full text-[11px] font-medium text-white/60"
                      key={league}
                      style={{
                        border: `1px solid ${teamColors.primary}40`,
                        background: `${teamColors.primary}10`,
                      }}
                    >
                      {league}
                    </span>
                  ))}
                </div>
              )}

              <div className="flex flex-wrap items-center gap-x-6 gap-y-1 mt-4 text-sm text-white/50">
                {sportsDbTeam?.intFormedYear && (
                  <span>
                    <i className="fas fa-landmark mr-1.5 text-white/30" />
                    Est. {sportsDbTeam.intFormedYear}
                  </span>
                )}
                {sportsDbTeam?.strStadium && (
                  <span>
                    <i className="fas fa-map-marker-alt mr-1.5 text-white/30" />
                    {sportsDbTeam.strStadium}
                    {sportsDbTeam.intStadiumCapacity &&
                      ` (${Number(sportsDbTeam.intStadiumCapacity).toLocaleString()})`}
                  </span>
                )}
                {coach && (
                  <span>
                    <i className="fas fa-user-tie mr-1.5 text-white/30" />
                    Coach: {coach}
                  </span>
                )}
              </div>
            </div>

            <div className="flex-shrink-0">
              <TeamDetailNextMatchCard
                decodedTeamName={decodedTeamName}
                formResults={formResults}
                liveMatch={liveMatch}
                loading={nextMatchLoading}
                nextMatch={nextMatch}
                sportsDbTeamId={sportsDbTeam?.idTeam}
                teamColors={teamColors}
                onMatchClick={onMatchClick}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamDetailHero;
